export const en = {
  table: {
    emptyState: {
      filtersAppliedHint: 'At least one filter is applied. Consider clearing some filters to see results.',
    },
  }
}